import { Component, forwardRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';
import { IEoTableFieldConfig } from './eo-table-field-config.model';
import { EoTableFieldFormComponent } from './partial/eo-table-field-form/eo-table-field-form.component';
import { EoFormConfig } from '../eo-form/eo-form.config';
import { EoFormPanelConfig } from '../eo-form-panel/eo-form-panel.model';
import { format, parseISO } from 'date-fns';

export interface IEoTableFieldProp {
  label: string;
  value: string;
  type: 'string' | 'number' | 'boolean' | 'date' | 'dropdown' | 'file';
}

@Component({
  selector: 'eo-table-field',
  templateUrl: './eo-table-field.component.html',
  styleUrls: ['./eo-table-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoTableFieldComponent),
      multi: true,
    },
  ],
})
export class EoTableFieldComponent<T> extends EoBaseFormControlComponent {
  @ViewChild('tableFieldForm') tableFieldForm?: EoTableFieldFormComponent;

  protected override _config?: IEoTableFieldConfig;
  override get config(): IEoTableFieldConfig | undefined {
    return this._config;
  }
  override set config(val: IEoTableFieldConfig | undefined) {
    this._config = val;
    this.setFormConfig();
  }

  protected override getLabel(): string {
    return this.label ?? this.config?.label ?? '';
  }

  formConfig?: EoFormConfig;
  formDialogVisible = false;

  onDialogSubmit(): void {
    const formData = this.tableFieldForm?.getFormData().panel;
    const value = [...this.config?.control.value, formData];
    this.config?.control.setValue(value);
    this.formDialogVisible = false;
  }

  onAddNew(): void {
    this.formDialogVisible = true;
    this.tableFieldForm?.form.reset();
  }

  onClear(): void {
    if (!this.config) return;
    this.config.control.setValue([]);
  }

  onDelete(item: any): void {
    if (!this.config) return;
    const tableData = this.config.control.value.filter((i: any) => i != item);
    this.config.control.setValue(tableData);
  }

  private setFormConfig(): void {
    this.formConfig = new EoFormConfig({
      submitButtonVisible: false,
      config: [
        new EoFormPanelConfig({
          name: 'panel',
          config: this.config?.formConfig || [],
        }),
      ],
      displayModeChangeVisible: false,
    });
  }

  protected getValue(item: any, prop: IEoTableFieldProp): string | number {
    switch (prop.type) {
      case 'number':
      case 'string':
        return item?.[prop.value] || '-';
      case 'boolean':
        return item?.[prop.value] ? 'ΝΑΙ' : 'ΟΧΙ';
      case 'date':
        return format(item?.[prop.value], 'dd/MM/yyyy') || '-';
      case 'dropdown':
        return item?.[prop.value]?.label || '-';
      case 'file':
        return item?.[prop.value]?.[0]?.name || '-';
      default:
        return '-';
    }
  }
}
